import React, { useEffect, useState } from "react";
import { any, reject, mapObjIndexed, values } from "ramda";
import { useMutation } from "@apollo/client";
import HCaptcha from "@hcaptcha/react-hcaptcha";

import Layout from "../Layout";
import Field from "./Field";
import * as UI from "./ui";
import { isBlank, isPresent } from "../../lib/presence";
import { presence } from "../../lib/validations";
import { createGuestSessionMutation } from "./queries";

const validations = {
  email: presence,
}

const validate = (values, validations) =>
  reject(isBlank,
    mapObjIndexed((validation, id) =>
      validation && validation(values[id], values), validations)
  )

const EmailForm = ({ setMode, sweepstakesId }) => {
  const [email, setEmail] = useState("")
  const [formErrors, setFormErrors] = useState({});
  const [showAllErrors, setShowAllErrors] = useState(false);
  const [createGuestSession, { loading }] = useMutation(createGuestSessionMutation);
  const [errorMessage, setErrorMessage] = useState(null);
  const [ captcha, setCaptcha ] = useState(null);

  const validateForm = () => { setFormErrors(validate({ email }, validations)) }
  useEffect(validateForm, [email]);

  const onSubmit = e => {
    e.preventDefault();

    if (any(isPresent, values(formErrors))) {
      setShowAllErrors(true)
      return;
    }

    createGuestSession({ variables: { sweepstakesId, email, captcha } }).then(
      () => {
        setMode("otp");
      }
    ).catch(() => {
        setErrorMessage("An error occurred. Please try again.");
      }
    );
  };

  return (
    <React.Fragment>
      <UI.Header>
        <UI.Heading>View Your Entries</UI.Heading>
        <UI.Subheading>Enter your email to receive a one-time passcode (OTP) to view your entries.</UI.Subheading>
      </UI.Header>
      <UI.FormWrapper>
        <UI.Captcha>
          <HCaptcha
            sitekey={import.meta.env.VITE_HCAPTCHA_SITE_KEY}
            onVerify={setCaptcha}
            onExpire={() => setCaptcha(null)}
          />
        </UI.Captcha>
        <UI.Form onSubmit={onSubmit}>
          <Field id="email" label="Email" type="email" onChange={e => setEmail(e.target.value)} value={email} errors={formErrors.email} touched={showAllErrors} required={true} />
          <UI.FieldGroup>
            <UI.ActionButton value="Submit" disabled={loading || !captcha} />
          </UI.FieldGroup>
          {errorMessage && <div>{errorMessage}</div>}
        </UI.Form>
      </UI.FormWrapper>
    </React.Fragment>
  );
};

export default EmailForm;
